import React from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import OTPVerificationPage from './OTPVerificationPage'

const OTPVerificationWrapper: React.FC = () => {
  const location = useLocation()
  const phoneNumber = location.state?.phoneNumber

  // Redirect to login if no phone number is provided
  if (!phoneNumber) {
    return <Navigate to="/login" replace />
  }

  return <OTPVerificationPage phoneNumber={phoneNumber} />
}

export default OTPVerificationWrapper
